﻿import { createFileRoute } from "@tanstack/react-router";
import { MsgMuralPage } from "@/paginas/pg_msg/msg-mural";

export const Route = createFileRoute("/_authenticated/msg-mural")({
  head: () => ({
    meta: [
      { title: "Mural de recados — Milky Moo Palmares" },
      {
        name: "description",
        content: "Recados da equipe da sorveteria: todos publicam e administradores moderam.",
      },
      { property: "og:title", content: "Mural de recados — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Avisos internos publicados pela equipe, com autor e data registrados.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: MsgMuralPage,
});
